<template>
  <div class="createPlayStep new-input-box" v-loading="loading">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-back
        @back="returnBack()"
        :title="['互动广场']"
        :subTitle="activityData.name"
        style="padding-bottom: 0"
      ></jd-back>
    </div>
    <div class="formBox">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 活动条件表单设置 -->
      <div class="secondstep" v-if="localStepNum == 0 || localStepNum == 1">
        <jd-tip style="margin-bottom: 10px"
          >云短信CRM ：订购到期时间
          {{ jdCrm.endTime }}（店铺需要搭配云短信CRM使用）。</jd-tip
        >
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          class="backgroundForm"
          label-width="150px"
        >
          <!-- 基本信息 -->
          <informationForm
            @selectPeopleSure="selectPeopleSure"
            :defaultActMember.sync="actMember"
            :defaultActivityStartTime.sync="activityStartTime"
            :defaultActivityEndTime.sync="activityEndTime"
            :plusObject.sync="ruleDTO.plusObject"
            :openCardStartTime.sync="ruleDTO.openCardStartTime"
            :openCardEndTime.sync="ruleDTO.openCardEndTime"
            :peopleSelected.sync="peopleSelected"
            ref="informationForm"
            v-model="ruleForm"
            :isEdit="false"
            :isNeedCusType="true"
            :cusType.sync="ruleDTO.cusType"
            :disabled="activityData.isStart"
            :localStepNum="localStepNum"
            :activityId="85"
            :showOpenCardTip="true"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          >
          </informationForm>
          <!-- 活动设置 -->
          <jd-title label="答题设置"></jd-title>
          <div class="mt20">
            <el-form-item label="答题模式：" required>
              <el-radio-group
                v-model="ruleDTO.answerMode"
                :disabled="activityData.isStart"
                @change="changeAnswerMode"
              >
                <el-radio :label="0"
                  >答对满
                  <el-input
                    v-model="ruleDTO.correctScore"
                    @input="
                      ruleDTO.correctScore = getNumberData(
                        1,
                        $event,
                        0,
                        1,
                        99999
                      )
                    "
                    @blur="handleScoreBlur"
                    class="w100 mlr8"
                    placeholder="请输入"
                    :disabled="ruleDTO.answerMode == 1 || activityData.isStart"
                  />
                  分即可参与<span>{{ prizeText }}</span></el-radio
                >
                <el-radio :label="1"
                  >答对<el-input
                    v-model="ruleDTO.correctItem"
                    @input="
                      ruleDTO.correctItem = getNumberData(
                        1,
                        $event,
                        0,
                        0,
                        99999
                      )
                    "
                    @blur="handleScoreBlur"
                    class="w100 mlr8"
                    placeholder="请输入"
                    :disabled="ruleDTO.answerMode == 0 || activityData.isStart"
                  />题即可参与<span>{{ prizeText }}</span></el-radio
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="分值设置："
              required
              v-if="ruleDTO.answerMode == 0"
            >
              <el-radio-group v-model="ruleDTO.scoreType" :disabled="activityData.isStart">
                <el-radio :label="0">按题目设置分值</el-radio>
                <el-radio :label="1">统一设置分值</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="题目设置：" required>
              <topicSetting
                :tableInfo="newTableInfo"
                :isMerge="ruleDTO.scoreType == 1 ? true : false"
                :selectIcon="selectIcon"
                :questions.sync="questions"
                :isDisabled="activityData.isStart"
              />
            </el-form-item>
            <el-form-item label="答题初始次数：" required>
              <span class="textStyle">每人初始有</span>
              <el-input-number
                v-model="ruleDTO.canAnswerNum"
                :min="1"
                :max="20"
                :step="1"
                :precision="0"
                class="w120 mlr8"
                placeholder="请输入"
              />
              <span class="textStyle"
                >次答题次数，获得{{ prizeText }}机会后不可再答题</span
              >
            </el-form-item>
            <el-form-item label="答题限时：" required>
              <el-radio-group
                v-model="ruleDTO.answerTimeType"
                @change="changeAnswerTimeType"
              >
                <el-radio :label="0">
                  <span>总答题最大时长为</span>
                  <el-input
                    v-model="ruleDTO.answerTimeLimit"
                    :min="1"
                    :max="100"
                    :step="1"
                    class="w120 mlr8"
                    placeholder="请输入"
                    @input="
                      ruleDTO.answerTimeLimit = getNumberData(
                        1,
                        $event,
                        0,
                        1,
                        999999
                      )
                    "
                    :disabled="ruleDTO.answerTimeType != 0"
                  />
                  <el-select
                    v-model="ruleDTO.answerTimeUnitType"
                    placeholder="请选择"
                    :disabled="ruleDTO.answerTimeType != 0"
                    class="w120"
                  >
                    <el-option label="分钟" :value="1" />
                    <el-option label="秒" :value="0" />
                  </el-select>
                </el-radio>
                <el-radio :label="1">
                  <span>每题答题最大时长为</span>
                  <el-input
                    v-model="answerTimeLimitOne"
                    :min="1"
                    :max="100"
                    :step="1"
                    class="w120 mlr8"
                    placeholder="请输入"
                    @input="
                      answerTimeLimitOne = getNumberData(
                        1,
                        $event,
                        0,
                        1,
                        999999
                      )
                    "
                    :disabled="ruleDTO.answerTimeType != 1"
                  />
                  <el-select
                    v-model="answerTimeUnitTypeOne"
                    placeholder="请选择"
                    :disabled="ruleDTO.answerTimeType != 1"
                    class="w120"
                  >
                    <el-option label="分钟" :value="1" />
                    <el-option label="秒" :value="0" />
                  </el-select>
                </el-radio>
                <el-radio :label="2">不限制</el-radio>
              </el-radio-group>
              <div class="showTip">题目超时未作答的题目将判定为未答题</div>
            </el-form-item>
            <el-form-item label="选项是否随机：">
              <el-checkbox v-model="ruleDTO.isRandom">
                开启选项随机后，每个用户题目和选项顺序都随机展示
              </el-checkbox>
            </el-form-item>
          </div>
          <!-- 奖品设置 -->
          <jd-title label="奖品设置"></jd-title>
          <div class="mt20">
            <el-form-item label="奖品获取方式：" required>
              <div class="flexc-cen-x">
                <el-radio-group
                  v-model="ruleDTO.awardType"
                  :disabled="isStartEdit"
                  @change="changeAwardType"
                >
                  <el-radio :label="1">通过抽奖获得</el-radio>
                  <el-radio :label="0">直接领取获得</el-radio>
                </el-radio-group>
                <el-tooltip placement="top">
                  <template #content>
                    <div>
                      1、直接领取获得：即完成答题且符合领奖要求后，可直接选择任一奖品领取；
                    </div>
                    <div>
                      2、通过抽奖获得：即完成答题且符合抽奖要求后，仅是获得抽奖机会，需要通过抽奖获取礼品，不一定能获得奖品；
                    </div>
                  </template>
                  <div class="question-style">
                    <span>奖品获取方式说明</span>
                    <i class="new-icon-box cursorPointer ml8"></i>
                  </div>
                </el-tooltip>
              </div>
            </el-form-item>
            <el-form-item label="奖品设置：">
              <lotteryPrize
                v-if="ruleDTO.awardType == 1"
                isShowLimit
                :dailyLimitDisabled="!backgroundOpacity"
                :prizeSettingList.sync="lotteryPrizeList"
                :activityData="activityData"
                :valueRow="valueRow"
                :backgroundOpacity="backgroundOpacity"
                :isDisabled="activityData.isStart"
                :isShowLottery="false"
                :isShowAddBtn="true"
                :isShowMoveBtn="true"
                :isCustomizeTip="true"
                :isShowDeleteBtn="true"
                :isShowTip="true"
                :minLimit="minLimit"
                :actType="85"
                :actEndTime="ruleForm.endTime"
                @addPrizeSetting="addSettingList"
              >
                <template>
                  <div class="textStyle">
                    至少添加1个奖品，最多添加20个奖品，奖品顺序可自行调整，C端活动页按相应顺序展示
                  </div>
                </template>
                <template #tipText>
                  <div>
                    1、最多设置20个奖项；实物奖品可上传图片，不上传使用默认图片。已有图片时点击可更换。
                  </div>
                  <div>
                    2、中奖率精确到小数点后两位，即0.01%，中奖率相加不得超过100%，不足100%的时候剩余部分分配给“谢谢参与”，谢谢参与不展示。
                  </div>
                  <div>
                    3、为避免客诉，奖品中奖概率不建议设置为0；若奖品中奖概率一定要设置为0，一切后果由商家承担。
                  </div>
                </template>
              </lotteryPrize>
              <div v-else>
                <newPrizeTable
                  :prizeList.sync="winPrizeList"
                  :isDisabled="activityData.isStart"
                  :tableInfo="prizeInfo"
                  :valueRow="valueRow"
                  :isShowUpLoadBtn="true"
                  :isShowMoveBtn="true"
                  :isShowAdd="true"
                  :maxPrizeCount="maxPrizeCount"
                  :actType="85"
                  :actEndTime="ruleForm.endTime"
                  @addPrize="addPrize"
                >
                  <template #dailyLimitName="{ scopeRow }">
                    <dailyLimitConfig
                      :row="scopeRow"
                      :backgroundOpacity="backgroundOpacity"
                      :limitBtnDisabled="backgroundOpacity"
                    ></dailyLimitConfig>
                  </template>
                </newPrizeTable>
              </div>
            </el-form-item>
          </div>
          <!-- 活动页设置 -->
          <activityPageSettings
            isShowShopName
            isShowMoreSet
            :cusTemplateJSON.sync="ruleDTO.cusTemplateJSON"
            :isNeedSetBG="true"
            :giftList="giftList"
            :templateId="templateId"
            :isShowDesignNumber="false"
            previewKey="url"
            templatekey="imageUrl"
            :widthNumber="750"
            :heightNumber="1624"
            :isCustomPreview="true"
            :downloadTemplateUrl="templateUrl"
            :designSpecificationsUrl="designSpecificationsUrl"
            themeTitle="主题"
            :defaultRgb="currrentRgb"
            v-model="customerPaperwork"
            @selectTemplate="selectTemplate"
          >
            <template #customPreview>
              <funAnswerDialog
                :ruleForm="ruleForm"
                :ruleDTO="ruleDTO"
                :backgroundImage="backgroundImage"
                :customerPaperwork="customerPaperwork"
                :templateObj="templateObj"
                :prizeList="commonPrizeList"
                :questions="questions"
              />
            </template>
            <template #otherSet>
              <!-- 自定义活动页设置 -->
              <el-form-item label="按钮设置:">
                <div class="upload-box">
                  <el-form-item label="按钮文案：" label-width="90px">
                    <el-input
                      show-word-limit
                      maxlength="8"
                      class="w160"
                      v-model="customerPaperwork.btnText"
                      placeholder="请输入"
                    ></el-input>
                    <jd-button
                      type="blueText"
                      @click="customerPaperwork.btnText = '开始答题'"
                      class="ml16"
                      :disabled="backgroundOpacity"
                      >重置</jd-button
                    >
                  </el-form-item>
                  <btnSet
                    :customerData="customerPaperwork"
                    bgKey="url2"
                    colorKey="rgb2"
                    :pw="450"
                    :ph="102"
                    bgLabelText="背景图"
                    labelText="按钮背景图"
                    :backgroundOpacity="backgroundOpacity"
                    :resetColor="currrentRgb2"
                  />
                </div>
              </el-form-item>
              <el-form-item label="奖品区域设置:">
                <div class="upload-box">
                  <el-form-item label="文案：" label-width="90px">
                    <el-input
                      show-word-limit
                      maxlength="4"
                      class="w160"
                      v-model="customerPaperwork.prizeBtnText"
                      placeholder="请输入"
                    ></el-input>
                    <jd-button
                      type="blueText"
                      @click="customerPaperwork.prizeBtnText = '奖品专区'"
                      class="ml16"
                      :disabled="backgroundOpacity"
                      >重置</jd-button
                    >
                  </el-form-item>
                  <btnSet
                    :customerData="customerPaperwork"
                    bgKey="url3"
                    colorKey="rgb3"
                    :pw="316"
                    :ph="72"
                    bgLabelText="背景图"
                    labelText="奖品区域背景图"
                    :backgroundOpacity="backgroundOpacity"
                    :resetColor="currrentRgb3"
                  />
                </div>
              </el-form-item>
              <el-form-item label="奖品剩余库存：">
                <el-radio-group v-model="customerPaperwork.isShowInventory">
                  <el-radio :label="false">不显示</el-radio>
                  <el-radio :label="true"
                    >显示（C端活动页奖品显示剩余库存）</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <!-- <el-form-item label="奖品价值：">
                <el-radio-group v-model="customerPaperwork.isShowPrice">
                  <el-radio :label="false">不显示</el-radio>
                  <el-radio :label="true"
                    >显示（C端活动页奖品显示奖品价值）</el-radio
                  >
                </el-radio-group>
              </el-form-item> -->
              <jd-title label="答题页设置"></jd-title>
              <div class="mt20">
                <div class="flexc">
                  <customUpload
                    :customerPaperwork="customerPaperwork"
                    bgKey="url4"
                    labelWidth="150px"
                    :pw="750"
                    :ph="1624"
                    labelText="答题页背景图:"
                    bgLabelText="答题页背景图"
                    btnType="blueLine"
                    :backgroundOpacity="backgroundOpacity"
                  />
                </div>
                <el-form-item label="未选中状态:">
                  <div class="upload-box">
                    <customText
                      :customerPaperwork="customerPaperwork"
                      labelText="背景:"
                      colorKey="rgb4"
                      labelWidth="100px"
                      :backgroundOpacity="backgroundOpacity"
                      :resetColor="currrentRgb4"
                    />
                    <customText
                      :customerPaperwork="customerPaperwork"
                      labelText="文字:"
                      colorKey="rgb5"
                      labelWidth="100px"
                      :backgroundOpacity="backgroundOpacity"
                      :resetColor="currrentRgb5"
                    />
                  </div>
                </el-form-item>
                <el-form-item label="选中状态:">
                  <div class="upload-box">
                    <customText
                      :customerPaperwork="customerPaperwork"
                      labelText="背景:"
                      colorKey="rgb6"
                      labelWidth="100px"
                      :backgroundOpacity="backgroundOpacity"
                      :resetColor="currrentRgb6"
                    />
                    <customText
                      :customerPaperwork="customerPaperwork"
                      labelText="文字:"
                      colorKey="rgb7"
                      labelWidth="100px"
                      :backgroundOpacity="backgroundOpacity"
                      :resetColor="currrentRgb7"
                    />
                    <customUpload
                      :customerPaperwork="customerPaperwork"
                      bgKey="url5"
                      labelWidth="100px"
                      :pw="60"
                      :ph="60"
                      labelText="ICON:"
                      bgLabelText="ICON图"
                      :backgroundOpacity="backgroundOpacity"
                    />
                  </div>
                </el-form-item>
                <customText
                  :customerPaperwork="customerPaperwork"
                  labelText="进度条颜色:"
                  colorKey="rgb8"
                  :backgroundOpacity="backgroundOpacity"
                  :resetColor="currrentRgb8"
                />
              </div>
              <jd-title label=" 结果页设置"></jd-title>
              <div class="mt20">
                <div class="flexc">
                  <customUpload
                    :customerPaperwork="customerPaperwork"
                    bgKey="url6"
                    labelWidth="150px"
                    :pw="750"
                    :ph="1624"
                    labelText="结果页背景图:"
                    bgLabelText="结果页背景图"
                    :backgroundOpacity="backgroundOpacity"
                  />
                </div>
                <customUpload
                  :customerPaperwork="customerPaperwork"
                  bgKey="url7"
                  labelWidth="150px"
                  :pw="224"
                  :ph="224"
                  labelText="答对图片:"
                  bgLabelText="答对图片"
                  :backgroundOpacity="backgroundOpacity"
                />
                <customUpload
                  :customerPaperwork="customerPaperwork"
                  bgKey="url8"
                  labelWidth="150px"
                  :pw="224"
                  :ph="224"
                  labelText="答错图片:"
                  bgLabelText="答错图片"
                  :backgroundOpacity="backgroundOpacity"
                />
              </div>
            </template>
          </activityPageSettings>
          <div v-if="ruleDTO.goShopSetting == 1">
            <el-form-item label="小程序appId:" required>
              <el-input
                type="textarea"
                placeholder="请输入小程序appId"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleDTO.goShopAppId"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
            </el-form-item>
            <el-form-item label="页面路径path:">
              <el-input
                type="textarea"
                placeholder="请输入小程序页面路径path"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleDTO.goShopUrl"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
              <div style="color: #f56c6c">
                注意：path若不写，则默认进入小程序主页。
              </div>
            </el-form-item>
          </div>
          <el-form-item
            label="指定链接:"
            required
            v-if="ruleDTO.goShopSetting == 2"
          >
            <el-input
              type="textarea"
              placeholder="请输入指定链接"
              style="width: 425px; margin-left: 8px"
              show-word-limit
              v-model="ruleDTO.goShopUrl"
              :maxlength="1000"
              :disabled="activityData.isStart"
            ></el-input>
            <div style="color: #f56c6c">
              注意：仅可填写京东域内的
              H5页面地址，不可设置外链。参考链接：https://m.jd.com/。
            </div>
          </el-form-item>
          <exposureList
            :defaultExposureSwitch.sync="ruleForm.isExposureItem"
            v-model="itemListFor"
            :backgroundOpacity="backgroundOpacity"
            :isLimit="true"
          ></exposureList>
          <sharFrom :sharePic="sharePic" v-model="ruleDTO"></sharFrom>
          <activityRules
            :isForceRemind.sync="isForceRemind"
            :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition"
            v-model="ruleForm.ruleDescription"
            @generateRule="generateRule"
            :activityData="activityData"
            :valueRow="valueRow"
          ></activityRules>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum == 0 || localStepNum == 1">
      <jd-button
        v-if="localStepNum != 0"
        style="margin-right: 8px"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >保存至草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button v-if="isSave" type="blue" @click="resetForm" v-preventReClick
          >保存设置</jd-button
        >
      </template>
    </div>

    <!-- 保存设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div v-loading="saveLoading">
        <div style="line-height: 25px; margin-bottom: 30px">
          <p>
            1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
          </p>
          <p>
            2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
          </p>
        </div>

        <el-checkbox v-model="checked" label="地址" name="partner"
          >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
        >
      </div>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button
          @click="handleDialogCloseAnoth()"
          type="blue"
          style="margin-left: 8px"
          v-loading="saveLoading"
          >确 定</jd-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  saveOrUpdateFunAnswer,
  getFunAnswerDetail,
} from "@/api/jhk/integralCenter/PointActivityAnalyticController.js";
import { sellerImage } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import informationForm from "./components/informationForm.vue";
import exposureList from "./components/exposureList.vue";
import sharFrom from "./components/sharFrom.vue";
import activityRules from "./components/activityRules.vue";
import activityPageSettings from "./components/activityPageSettings.vue";
import funAnswerDialog from "./components/newActPreviews/fun-answer-dialog.vue";
import newPrizeTable from "./components/newPrizeTable/index.vue";
import {
  useOutputBasicInformation,
  useInputBasicInformation,
  useUpdateBasicInformation,
  useValidateBasicInformation,
  useValidateActEndInfomation,
} from "./components/commDataHook/useBasicInformation.js";
import { useJdCrm } from "./components/commDataHook/useCommReq.js";
import btnSet from "./components/commCustomizationSet/btnSet.vue";
import topicSetting from "./components/topicSetting/index.vue";
import lotteryPrize from "./components/lotteryPrize/index.vue";
import dailyLimitConfig from "@/views/interactiveMarketing/activity/components/dailyLimitConfig.vue";
import customUpload from "./components/commCustomizationSet/customUpload.vue";
import customText from "./components/commCustomizationSet/customText.vue";
export default {
  components: {
    informationForm,
    exposureList,
    sharFrom,
    activityRules,
    activityPageSettings,
    funAnswerDialog,
    newPrizeTable,
    btnSet,
    topicSetting,
    lotteryPrize,
    dailyLimitConfig,
    customUpload,
    customText,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    valueRow: {
      type: Object,
      default: () => {},
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      questions: [],
      designSpecificationsUrl:
        "https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/jd-answer-main-design.png",
      maxPrizeCount: 5,
      prizeInfo: [
        {
          label: "奖品类型",
          prop: "prizeType",
          slot: "prizeTypeSlot",
          minWidth: 120,
        },
        {
          label: "值",
          prop: "price",
          minWidth: 100,
        },
        {
          label: "奖品名称（12字以内）",
          prop: "title",
          slot: "titleSlot",
          slotHead: "titleHeader",
          minWidth: 200,
        },
        {
          label: "奖品数量",
          prop: "totalAmount",
          slot: "totalAmountSlot",
          minWidth: 120,
        },
        {
          label: "每日发放限额",
          slotName: "dailyLimitName",
          slot: "dailyLimit",
          minWidth: 120,
        },
        {
          label: "图片",
          prop: "logo",
          slot: "logoSlot",
          minWidth: 120,
        },
        {
          label: "操作",
          prop: "operation",
          slot: "operationSlot",
          fixed: "right",
          minWidth: 260,
        },
      ],
      winPrizeList: [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          singleAmount: "",
          prizeObjectType: 0,
        },
      ],
      minLimit: 1,
      lotteryPrizeList: [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: null,
          price: null,
          title: "",
          totalAmount: null,
          percentage: null,
          logo: "",
          prizeObjectType: 0,
        },
      ],
      questionInfo: [
        {
          label: "题目类型",
          slot: "questionTypeSlot",
          minWidth: 100,
        },
        {
          label: "题目名称（50个字以内）",
          slot: "questionNameSlot",
          minWidth: 100,
        },
        {
          label: "题目内容",
          slot: "questionContentSlot",
          minWidth: 100,
        },
        {
          label: "操作",
          prop: "operation",
          slot: "operationSlot",
          minWidth: 100,
        },
      ],
      jdCrm: {
        endTime: "",
      },
      isDisabledTotal: true,
      limitNum: 20,
      isIndex: false,
      isShowCustom: true,
      isShowMoveBtn: true,
      isLimit: true,
      isKeyActivity: 0,
      placementPosition: [],
      isForceRemind: 0,
      templateUrl:
        "https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/%E7%99%BE%E5%8F%98%E8%B6%A3%E7%AD%94.psd",
      saveLoading: false,
      loading: false,
      templateObj: {},
      currrentRgb: "",
      currrentRgb2: "",
      currrentRgb3: "",
      currrentRgb4: "",
      currrentRgb5: "",
      currrentRgb6: "",
      currrentRgb7: "",
      currrentRgb8: "",
      customerPaperwork: {
        title: "百变答题", //活动主题
        desc: "", //描述
        titleColor: "#000000", //主题字体颜色
        url2: "", //按钮背景图
        url3: "", //奖品区域背景图
        url4: "", //答题背景图
        url5: "", //选项选中ICON
        url6: "", //结果页活动背景图
        url7: "", //答对图片
        url8: "", //未答对图片
        rgb2: "#ffffff", //按钮字体颜色
        rgb3: "#000000", //奖品区域文字色
        rgb4: "#FCF9F2", //选项未选中背景颜色
        rgb5: "#1A1A1A", //选项未选中文字颜色
        rgb6: "#71BFFF", //选项选中背景颜色
        rgb7: "#ffffff", //选项选中文字颜色
        rgb8: "#53A8FF", //进度条颜色
        btnText: "开始答题",
        prizeBtnText: "奖品专区",
        isShowInventory: true, //是否显示库存
        isShowPrice: false, //是否显示奖品价值
      },
      actMember: "1",
      peopleSelected: [],
      templateId: "",
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      giftList: [],
      itemListFor: [], //商品弹框选择商品数据
      joinBlackList: false,
      checked: false,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      ruleForm: {
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        allowLevel: "-1",
        activityName: "",
        openCardFollow: 0,
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "",
        isValidBlackList: 0,
        // 购物条件 - 累计完成订单笔数
        orderCompleteLimitCount: "", // 最小订单笔数
        orderCompleteMaxCount: "", // 最大订单笔数
        // 购物条件 - 累计完成订单金额
        orderCompleteLimitPayment: "", // 最小订单金额
        orderCompleteMaxPayment: "", // 最大订单金额
        // 购物条件 - 最后一次订单完成时间
        lastOrderCompleteTimeType: 0, // 时间类型: 0-不限, 1-距当前天数范围, 2-指定时间段
        lastOrderCompleteStartDay: "", // 距当前开始天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteEndDay: "", // 距当前结束天数 (当 lastOrderCompleteTimeType='1' 时)
        lastOrderCompleteStartTime: "", // 指定开始时间 (当 lastOrderCompleteTimeType='2' 时)
        lastOrderCompleteEndTime: "", // 指定结束时间 (当 lastOrderCompleteTimeType='2' 时)
      },
      sharePic: "https://cdn-image.yucrm.cn/hd/images/fun-answer-share.png",
      answerTimeLimitOne: "",
      answerTimeUnitTypeOne: 1,
      ruleDTO: {
        answerMode: 0,
        correctScore: "",
        correctItem: "",
        scoreType: 0,
        canAnswerNum: 1, //答题初始次数
        answerTimeType: 0, //答题时长类型
        answerTimeLimit: "",
        answerTimeUnitType: 1, //答题时长单位
        isRandom: true, //是否随机选项,
        awardType: 1, //奖品获取方式
        customerPaperwork: "",
        cusTemplateJSON: "",
        cusType: 0, //新老客类型
        plusObject: 0,
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "https://cdn-image.yucrm.cn/hd/images/fun-answer-share.png",
        openCardStartTime: "",
        goShopSetting: 0, //进店设置
        goShopAppId: "", //小程序appId
        goShopUrl: "", //小程序页面路径
      },
      activityStartTime: null,
      activityEndTime: null,
      templateJson: {
        templateUItype: "",
      },
      levelList: [],
      isDraft: false,
    };
  },
  computed: {
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    isStartEdit() {
      return this.activityData.isStart;
    },
    backgroundImage() {
      return this.ruleDTO.cusTemplateJSON
        ? JSON.parse(this.ruleDTO.cusTemplateJSON).activityBgImg
        : this.templateObj.url;
    },
    newTableInfo() {
      if (this.ruleDTO.answerMode == 0) {
        const hasRemanentCol = this.questionInfo.some(
          (col) => col.slot === "scoreSlot"
        );
        if (hasRemanentCol) return;

        // 找到操作列的位置，在操作列前面插入（更可靠）
        const operationIndex = this.questionInfo.findIndex(
          (col) => col.prop === "operation" || col.slot === "operationSlot"
        );
        const insertIndex =
          operationIndex > -1 ? operationIndex : this.questionInfo.length - 1;

        this.questionInfo.splice(insertIndex, 0, {
          label: "答对分值",
          prop: "score",
          minWidth: "130",
          slot: "scoreSlot",
        });
      } else if (this.ruleDTO.answerMode == 1) {
        const hasRemanentCol = this.questionInfo.some(
          (col) => col.slot === "scoreSlot"
        );
        if (hasRemanentCol) {
          this.questionInfo.splice(
            this.questionInfo.findIndex((col) => col.slot === "scoreSlot"),
            1
          );
        }
      }
      return this.questionInfo;
    },
    selectIcon() {
      return this.customerPaperwork.url5
        ? this.customerPaperwork.url5
        : this.templateObj.url5;
    },
    commonPrizeList() {
      return this.ruleDTO.awardType == 1
        ? this.lotteryPrizeList
        : this.winPrizeList;
    },
    allTotalScore() {
      return this.questions.reduce((acc, cur) => acc + Number(cur.score), 0);
    },
    prizeText() {
      return this.ruleDTO.awardType == 1 ? "抽奖" : "领奖";
    },
    timeTypeText() {
      const types = {
        0: this.ruleDTO.answerTimeUnitType,
        1: this.answerTimeUnitTypeOne,
      };
      return types[this.ruleDTO.answerTimeType] == 0 ? "秒" : "分钟";
    },
  },
  watch: {},
  created() {
    this.ruleDTO.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleDTO.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
  },
  mounted() {
    this.getLevel();
    useJdCrm(this);
    this.buriedPoint(1, "百变趣答", "互动管理", "互动活动");
  },

  methods: {
    changeAwardType() {
      this.lotteryPrizeList = [
        {
          assetsId: null,
          prizeType: null,
          price: null,
          title: "",
          totalAmount: null,
          percentage: null,
          logo: "",
          prizeObjectType: 0,
        },
      ];
      this.winPrizeList = [
        {
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: 0,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          singleAmount: "",
          prizeObjectType: 0,
        },
      ];
    },
    addSettingList() {
      this.lotteryPrizeList.push({
        assetsId: null,
        prizeType: null,
        price: null,
        title: "",
        totalAmount: null,
        percentage: null,
        logo: "",
        prizeObjectType: 0,
      });
    },
    addPrize() {
      if (this.winPrizeList.length >= this.maxPrizeCount) {
        this.$message.warning(`最多只能添加${this.maxPrizeCount}个奖项`);
        return;
      }
      this.winPrizeList.push({
        assetsId: null, // 资产项id(计划id优惠卷id商品id)
        prizeType: 0,
        price: null,
        logo: null,
        title: "",
        totalAmount: null,
        singleAmount: "",
        prizeObjectType: 0,
      });
    },
    changeAnswerTimeType() {
      this.ruleDTO.answerTimeLimit = "";
      this.ruleDTO.answerTimeUnitType = 1;
      this.answerTimeLimitOne = "";
      this.answerTimeUnitTypeOne = 1;
    },
    changeAnswerMode() {
      this.ruleDTO.correctScore = "";
      this.ruleDTO.correctItem = "";
      this.ruleDTO.scoreType = 0;
    },
    // 答对条件失焦统一校验
    handleScoreBlur() {
      // 答题模式：0 - 答对满X分即可参与抽奖/领奖，1 - 答对X题即可参与抽奖/领奖
      if (this.ruleDTO.answerMode == 0 && this.questions.length > 0) {
        // 答对满X分模式：校验分数不超过累计总分
        const score = this.ruleDTO.correctScore;
        // 仅当有输入值、有题目且总分&gt;0时才校验
        if (Number(score) > this.allTotalScore) {
          this.$message.warning("分值不可超过累计题目总分");
          this.ruleDTO.correctScore = String(this.allTotalScore);
        }
      } else if (this.ruleDTO.answerMode == 1) {
        // 答对X题模式：校验题数不超过总题数
        const item = Number(this.ruleDTO.correctItem);
        // 仅当有输入值且有题目时才校验
        if (item && this.questions.length > 0 && item > this.questions.length) {
          this.$message.warning("答对题数不可超过累计题目总数");
          this.ruleDTO.correctItem = String(this.questions.length);
        }
      }
    },
    resetRgb(row, configJson) {
      this.currrentRgb = row.rgb;
      this.currrentRgb2 = row.rgb2;
      this.currrentRgb3 = row.rgb3;
      this.currrentRgb4 = configJson.rgb4;
      this.currrentRgb5 = configJson.rgb5;
      this.currrentRgb6 = configJson.rgb6;
      this.currrentRgb7 = configJson.rgb7;
      this.currrentRgb8 = configJson.rgb8;
    },
    initCustomizeData(row) {
      const configJson = row.configJson ? JSON.parse(row.configJson) : {};
      this.customerPaperwork.titleColor = row.rgb || "#000000";
      this.customerPaperwork.rgb2 = row.rgb2 || "#ffffff";
      this.customerPaperwork.rgb3 = row.rgb3 || "#000000";
      this.customerPaperwork.rgb4 = configJson.rgb4 || "#FCF9F2";
      this.customerPaperwork.rgb5 = configJson.rgb5 || "#1A1A1A";
      this.customerPaperwork.rgb6 = configJson.rgb6 || "#71BFFF";
      this.customerPaperwork.rgb7 = configJson.rgb7 || "#ffffff";
      this.customerPaperwork.rgb8 = configJson.rgb8 || "#53A8FF";
      this.resetRgb(row, configJson);
    },
    selectTemplate(index, id, item) {
      this.templateObj = item;
      this.templateId = id;
      this.templateJson.templateUItype = index;
      this.initCustomizeData(item);
    },

    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: "",
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.loading = false;
      this.giftList =
        data.records && data.records.length > 0
          ? data.records.map((item) => {
              return {
                ...item,
                days: item.activityStartTime
                  ? this.getDaysBetween(
                      item.activityStartTime,
                      item.activityEndTime
                    )
                  : "",
              };
            })
          : [];
      if (!this.templateId && this.giftList.length > 0) {
        let obj = this.giftList[0];
        this.templateObj = obj;
        this.templateId = obj.id;
        this.templateJson.templateUItype = 0;
        this.initCustomizeData(this.templateObj);
      } else if (this.templateId) {
        let arr = this.giftList.filter((item) => item.id == this.templateId);
        this.templateObj = arr[0];
        const configJson = this.templateObj.configJson
          ? JSON.parse(this.templateObj.configJson)
          : {};
        this.templateId = this.templateId;
        this.resetRgb(this.templateObj, configJson);
      }
      this.pageData.total = data.total * 1;
    },
    //会员等级
    getLevel() {
      if (this.valueRow && this.valueRow.id) {
        this.loading = true;
      }
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
          this.getDetail();
        })
        .catch((res) => {
          this.loading = false;
        });
    },
    questionType(type) {
      const typeMap = {
        1: "单选题",
        2: "多选题",
        4: "图片单选题",
        5: "图片多选题",
      };
      return typeMap[type] || "";
    },
    //生成规则
    generateRule() {
      let text1 = `本次活动一共${this.questions.length}道题目满分${
          this.allTotalScore
        }分，题型包含：${[...new Set(this.questions
          .map((item) => this.questionType(item.type)))]
          .join("、")}；答${
          this.ruleDTO.answerMode == 0 ? "题总分" : "对"
        }大于等于${
          this.ruleDTO.answerMode == 0
            ? this.ruleDTO.correctScore
            : this.ruleDTO.correctItem
        }${this.ruleDTO.answerMode == 0 ? "分" : "题"}，即可获得${
          this.prizeText
        }机会；`,
        text2 = `全场答题总时长${this.ruleDTO.answerTimeLimit}${this.timeTypeText}，总时长耗尽将自动交卷，答完一题即刻公布答题结果；`,
        text3 = "题目超时未作答或中途退出，将判定为未答题；",
        text4 = "每位用户的题目顺序、选项展示顺序均随机；",
        text5 = `每位用户初始拥有${this.ruleDTO.canAnswerNum}次答题机会，获得${this.prizeText}机会后不可再次答题，未达标可消耗剩余次数重答；`,
        text6 = `奖品获取方式：${
          this.ruleDTO.awardType == 1 ? "通过抽奖获得" : "直接领取获得"
        }，即完成答题且符合${this.prizeText}要求后，${
          this.ruleDTO.awardType == 1
            ? "仅是获得抽奖机会，需要通过抽奖获取礼品；"
            : "可直接选择任一奖品领取；"
        }\n`,
        text7 = "所有奖品数量有限，先到先得，送完即止。",
        secondText = "\n二、【如何参与】",
        thirdText = "\n三、【活动奖品】",
        fourthText = "\n四、【注意事项】";
      if (this.ruleDTO.answerTimeType == 1) {
        text2 = `每题作答限时${this.answerTimeLimitOne}${this.timeTypeText}，超时将进入下一题，答完一题即刻公布答题结果；`;
      } else if (this.ruleDTO.answerTimeType == 2) {
        text2 = "无作答时间限制，答完一题即刻公布答题结果；";
      }

      this.commonPrizeList.forEach((item, index) => {
        text6 += `（${index + 1}）${item.title}，共${
          item.totalAmount ? item.totalAmount : 1
        }份${item.prizeType == 3 ? "，单份奖品价值" + item.price + "元" : ""}${
          this.ruleDTO.awardType == 1 ? `，中奖概率：${item.percentage}%` : ""
        }；${index != this.commonPrizeList.length - 1 ? "\n" : ""}`;
      });
      if (this.ruleDTO.participateType == 1) {
        text1 =
          "参与方式：活动期间内进入活动时自动判断用户身份，符合条件则自动报名；";
      }
      const { firstText, precautions } = this.getCommonText(
        this.levelList,
        this.ruleForm,
        this.ruleDTO,
        this.actMember
      );
      const list = [text1, text2, text3, text5];
      const arr = [text6];
      if (this.ruleDTO.isRandom) {
        // 不能重复添加
        if (list.indexOf(text4) == -1) {
          list.splice(3, 0, text4);
        }
      }
      if (this.ruleDTO.awardType == 0) {
        if (arr.indexOf(text7) == -1) {
          arr.splice(1, 0, text7);
        }
      }
      let Arr1 = [
        firstText,
        [secondText, ...list],
        [thirdText, ...arr],
        [fourthText, precautions],
      ];
      let newText = "";
      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = newText + newNum + "." + row + "\n";
            } else {
              newText = newText + row + "\n";
            }
            newNum = newNum + 1;
          }
        });
      });
      this.ruleForm.ruleDescription = newText.trim();
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },

    // 下一步
    resetForm() {
      // 公共校验
      if (!useValidateBasicInformation(this)) {
        return;
      }
      if (this.questions.length == 0) {
        this.$message.warning("请设置题目");
        return;
      }
      // 非公共部分校验
      if (this.ruleDTO.answerMode == 0) {
        if (!this.ruleDTO.correctScore) {
          this.$message.warning("请输入答对分数");
          return;
        }
        if (Number(this.ruleDTO.correctScore) > this.allTotalScore) {
          this.$message.warning("分值不可超过累计题目总分");
          return;
        }
      } else if (this.ruleDTO.answerMode == 1) {
        if (!this.ruleDTO.correctItem) {
          this.$message.warning("请输入答对题数");
          return;
        }
        if (Number(this.ruleDTO.correctItem) > this.questions.length) {
          this.$message.warning("答对题数不可超过累计题目总数");
          return;
        }
      }

      if (this.ruleDTO.answerMode == 0) {
        const flag = this.questions.some((item) => !item.score);
        if (flag) {
          this.$message.warning("请完善题目的答对分值");
          return;
        }
      }
      if (!this.ruleDTO.canAnswerNum) {
        this.$message.warning("请输入答题初始次数");
        return;
      }
      if (this.ruleDTO.answerTimeType == 0) {
        if (!this.ruleDTO.answerTimeLimit) {
          this.$message.warning("请输入总答题限时");
          return;
        }
      } else if (this.ruleDTO.answerTimeType == 1) {
        if (!this.answerTimeLimitOne) {
          this.$message.warning("请输入每题答题限时");
          return;
        }
      }
      // 判断是抽奖
      if (this.ruleDTO.awardType == 1) {
        const flag = this.lotteryPrizeList.some(
          (item) =>
            !item.title ||
            !item.prizeType ||
            !item.totalAmount ||
            !item.percentage
        );
        if (flag) {
          this.$message.warning("请完善奖品信息");
          return;
        }
      } else {
        const flag = this.winPrizeList.some(
          (item) => !item.title || !item.prizeType || !item.totalAmount
        );
        if (flag) {
          this.$message.warning("请完善奖品信息");
          return;
        }
      }
      if (!useValidateActEndInfomation(this)) {
        return;
      }
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      // // 奖品必选
      // if (this.prizeSetting.some((item) => !item.prizeType)) {
      //   this.$message.warning("请至少选择一个奖品");
      //   return;
      // }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    async handleDialogCloseAnoth() {
      const obj = useInputBasicInformation(this, 85);
      // 题目设置
      obj.questions = this.questions.map((item, index) => {
        return { ...item, sort: index + 1 };
      });
      // 奖品处理
      let prizeListCommon = this.commonPrizeList;
      prizeListCommon = prizeListCommon.filter((item) => item.prizeType);
      obj.pointActivityPrizeDTOList = prizeListCommon;
      // 答题限时单独处理
      if (this.ruleDTO.answerTimeType == 1) {
        obj.ruleDTO.answerTimeLimit = this.answerTimeLimitOne;
        obj.ruleDTO.answerTimeUnitType = this.answerTimeUnitTypeOne;
      }
      if (this.checked == true || this.isDraft) {
        this.saveLoading = true;
        if (this.activityData.isStart) {
          const params = useUpdateBasicInformation(obj, prizeListCommon, this);
          params.questions = obj.questions;
          updateCommon(params)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        } else {
          if (this.isDraft) {
            obj.status = 5;
            delete obj.templateJson;
          } else {
            // 保存正式活动不需要status
            if (obj.status) delete obj.status;
            if (!this.activityData.isCopy) {
              // 未开始活动修改
              if (this.valueRow && this.valueRow.id) {
                obj.pointActivityId = this.valueRow.id;
                obj.id = this.valueRow.id;
              }
            } else {
              delete obj.templateJson;
            }
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
            // 草稿箱不需要传 pointActivityId
            if (obj.pointActivityId) delete obj.pointActivityId;
            // 草稿箱保存正式活动删除id
            if (!obj.status) {
              delete obj.id;
            }
          }
          saveOrUpdateFunAnswer(obj)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！");
                  this.$emit("returnBack", true);
                } else {
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        }
      } else {
        this.saveLoading = false;
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.valueRow && this.valueRow.id) {
        getFunAnswerDetail({ id: this.valueRow.id })
          .then((res) => {
            const { pointActivityPrizeDTOList, questions } = res.data;
            useOutputBasicInformation(res.data, this);
            if (!this.activityData.isCopy) {
              // 奖品回显
              if (res.data.ruleDto.awardType == 1) {
                this.lotteryPrizeList = pointActivityPrizeDTOList || [
                  {
                    assetsId: null, // 资产项id(计划id优惠卷id商品id)
                    prizeType: null,
                    price: null,
                    title: "",
                    totalAmount: null,
                    percentage: null,
                    logo: "",
                    prizeObjectType: 0,
                  },
                ];
              } else {
                this.winPrizeList = pointActivityPrizeDTOList || [
                  {
                    assetsId: null, // 资产项id(计划id优惠卷id商品id)
                    prizeType: null,
                    price: null,
                    logo: null,
                    title: "",
                    totalAmount: null,
                    singleAmount: "",
                    prizeObjectType: 0,
                  },
                ];
              }
            }
            if (res.data.ruleDto.answerTimeType == 1) {
              this.answerTimeLimitOne = res.data.ruleDto.answerTimeLimit;
              this.answerTimeUnitTypeOne = res.data.ruleDto.answerTimeUnitType;
              this.ruleDTO.answerTimeUnitType = 1;
              this.ruleDTO.answerTimeLimit = "";
            }
            // 题目回显
            if (questions && questions.length > 0) {
              this.questions = questions;
            }
            this.getPolite();
          })
          .catch((res) => {});
      } else {
        this.activityStartTime = this.$getDate(30)[0];
        this.activityEndTime = this.$getDate(30)[1];
        this.hdTaskTemplateGroup();
      }
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.localStepNum = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 28px 28px 1px 24px;
    margin-bottom: 29px;
  }
  .showTip {
    color: red;
    font-size: 14px;
  }
  .openTip {
    margin-left: 8px;
    color: #333333;
  }
  .rule_box {
    background-color: #f7f8fa;
    padding: 16px 16px 1px;
    border-radius: 4px;
    font-size: 14px;
  }
  .upload-box {
    width: 450px;
    padding: 20px 20px 1px;
    background: #f4f6fa;
    border-radius: 4px;
  }

  .textStyle {
    color: #333333;
  }

  .question-style {
    margin-left: 12px;
    display: flex;
    align-items: center;
    color: #3159ff;
  }
}

.ml8 {
  margin-left: 8px;
}

.mlr8 {
  margin: 0 8px;
}

.ml16 {
  margin-left: 16px;
}

.w100 {
  width: 100px;
}
.w120 {
  width: 120px;
}
.w80 {
  width: 80px;
}
.w160 {
  width: 160px;
}
.w200 {
  width: 200px;
}
.w60 {
  width: 60px;
}

.flex-c {
  display: flex;
  flex-direction: column;
}
.flex-r {
  display: flex;
  align-items: center;
}
/deep/ .el-tooltip__popper {
  font-size: 14px !important;
}
</style>
